var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pos-container" },
    _vm._l(_vm.filteredItems, function (item) {
      return _c(
        "b-card",
        {
          key: item.id,
          staticClass: "pos-item",
          on: {
            click: function ($event) {
              return _vm.itemSelected(item)
            },
          },
        },
        [
          item.name.length >= 12
            ? _c(
                "div",
                {
                  staticClass: "card-img-overlay",
                  attrs: { title: item.name },
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-img-square" },
                    [
                      _c("picture-placeholder", {
                        attrs: {
                          "text-in": item.name.toLowerCase(),
                          color: "#fff",
                          backgroundColor: "#bbb",
                          pictureUrl: item.image_md_uri || item.image_uri,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-title-local" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-text" }, [
                    _vm._v(_vm._s(item.default_rate)),
                  ]),
                ]
              )
            : _c("div", { staticClass: "card-img-overlay" }, [
                _c(
                  "div",
                  { staticClass: "card-img-square" },
                  [
                    _c("picture-placeholder", {
                      attrs: {
                        "text-in": item.name.toLowerCase(),
                        color: "#fff",
                        backgroundColor: "#bbb",
                        pictureUrl: item.image_md_uri || item.image_uri,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "card-title-local" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "card-text" }, [
                  _vm._v(_vm._s(item.default_rate)),
                ]),
              ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }